export default __webpack_public_path__ + "static/media/pay-orderHover.16b31fbd.svg";